/*
 * @Author: Teemo Ding
 * @Date: 2021-10-14 10:59:09
 * @LastEditTime: 2021-10-18 14:28:44
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/components/LinkModule/hooks.ts
 */
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { ChannelType } from 'src/types/common/SalesChannel';
import { getConfig } from '@/src/constrains/GlobalProvider/slice';
import { useSelector } from 'react-redux';
import { LinkModuleType } from '@/src/types/common/linkType';

//import { LinkModuleType } from 'src/types/common/linkType';
const homepageUuid = 'cf93058f-7a36-48c0-a825-285086cd3ff5';
const allProductsUuid = '69f8082a-1511-4f68-bb3d-3d7276001704';
const cartUuid = '0e4c66fc-f882-4bea-bbce-f5ab811241a9';
const profileUuid = 'b6ccd975-d2e6-46e9-a284-501313e9b54f';
const customerServiceUuid = '7c0b1c58-abe7-47a0-809e-fa8d46812dce';
const shareMiniProgramUuid = 'f9d2352d-2c06-4e86-8311-5520d95c5285';

const checkIsInternal = (linkType, uuid) => {
  if (linkType === LinkModuleType.SysModule) {
    return [
      homepageUuid,
      allProductsUuid,
      cartUuid,
      profileUuid,
      customerServiceUuid,
    ].includes(uuid);
  }
  return [
    LinkModuleType.None,
    LinkModuleType.Product,
    LinkModuleType.Collection,
    LinkModuleType.ContentPage,
    LinkModuleType.LegalPage,
  ].includes(linkType);
};

const _list = () => {
  return useSelector(getConfig()) || [];
};
//For general sales channel content,
const useSalesChannelGeneralLinkSet = ({ contentUuid }) => {
  let list = _list();
  list = list.filter((i) => {
    return i.uuid !== shareMiniProgramUuid;
  });
  return {
    selectedLinkType: list,
    scopeVariables: {
      SalesChannelContent: contentUuid,
    },
  };
};
const useSalesChannelProductLinkSet = ({ salesChannelUuid }) => {
  let list = _list();
  list = list.filter((i) => {
    return i.linkType !== LinkModuleType.ShareMiniProgram;
  });
  return {
    linkTypeList: list,
    scopeVariables: {
      SalesChannel: salesChannelUuid,
      SalesChannelOuterContent: salesChannelUuid,
    },
  };
};

//For sales channel action bar
const useSalesChannelMiniProgramLinkSet = ({ contentUuid }) => {
  const channelType = useSalesChannelType();
  //const channelType = get(salesChannel, 'channelType');
  let list = _list();

  if (channelType === ChannelType.MiniProgram) {
  }
  if (channelType === ChannelType.Website) {
    list = list.filter((i) => {
      return i.uuid !== shareMiniProgramUuid;
    });
  }
  return {
    selectedLinkType: list,
    scopeVariables: {
      SalesChannelContent: contentUuid,
    },
  };
};

export {
  useSalesChannelGeneralLinkSet,
  useSalesChannelMiniProgramLinkSet,
  useSalesChannelProductLinkSet,
  checkIsInternal,
};
